// src/utils/walkiePeerName.js
//
// A Walkie peer's name from the CRM's own records, keyed by the peer's uid (docs/bugs/walkie_caller_name_trust_BUG.md,
// 2026-10-09): the AI list for a mind, else the user record (users/{uid}, or the server-written directory
// publicUsers/{uid}). Never a name the peer's own tab sends or publishes (an offer's fromName, a presence displayName):
// any staff member's browser can write those, so they could name anyone.

export const UNKNOWN_PEER = 'A teammate'

/** The trusted name for this uid, or null when the records given do not know it. */
export function trustedPeerName(uid, { aiInstance = null, record = null } = {}) {
  if (!uid) return null
  if (aiInstance && aiInstance.displayName) return aiInstance.displayName
  const name = String((record && (record.identity?.displayName || record.displayName)) || '').trim()
  return name || null
}
